import Table from '@/common/components/Table';
import AddLeadOrderPopup from './components/AddLeadOrderPopup';
import { getHeaders } from './helpers/getHeaders';
import { getRaws } from './helpers/getRaws';
import useLeadOrders from './hooks/useLeadOrders';
import { Wrapper } from './LeadOrders.styles';

const LeadOrders = () => {
	const {
		data,
		showAddPopup,
		setShowAddPopup,
		openAddPopup,
		loadData,
		shouldShowLoading,
	} = useLeadOrders();

	return (
		<>
			<Wrapper>
				<Table
					style={{ width: '800px' }}
					className='styled-table'
					headersArray={getHeaders(openAddPopup)}
					raws={getRaws(data, openAddPopup)}
					noDataCols={7}
					loading={shouldShowLoading}
				/>
			</Wrapper>
			{showAddPopup && (
				<AddLeadOrderPopup
					setShow={setShowAddPopup}
					onCreated={loadData}
					selectedQueue={showAddPopup.queue}
				/>
			)}
		</>
	);
};

export default LeadOrders;
